// Firebase Context
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_APPS = 'SET_APPS'